export default "__VITE_ASSET__BUI32SaH__"